export default __webpack_public_path__ + "static/media/icon-close.7485b772.svg";